import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid, MenuItem, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

function UpdateYear() {
  const id = window.location.pathname.split("/")[2];
  const [year, setYear] = useState("");
  const [status, setStatus] = useState("active");
  const [redirect, setRedirect] = useState(false);
  const [notification, setNotification] = useState({ open: false, color: "success", message: "" });

  const showMessage = (message, color = "success", shouldRedirect = false) => {
    setNotification({ open: true, color, message });
    setTimeout(() => {
      setNotification({ open: false, color, message: "" });
      if (shouldRedirect) setRedirect(true);
    }, 2500);
  };

  useEffect(() => {
    const loadYear = async () => {
      if (init() !== "success") return;
      try {
        const resp = await axios.get(`${Constants.getUrls.getAllYears}/${id}`);
        setYear(resp?.data?.data?.year || "");
        setStatus(resp?.data?.data?.status || "active");
      } catch (error) {
        showMessage(error?.response?.data?.message || "Unable to load year.", "error");
      }
    };

    if (id) {
      loadYear();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${Constants.putUrls.updateYear}${id}`, { year, status });
      showMessage("Year updated successfully!", "success", true);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to update year.", "error");
    }
  };

  if (redirect) return <Navigate to="/years" />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
            <MDTypography variant="h6" color="white">
              Update Year
            </MDTypography>
          </MDBox>
          <MDBox py={3} px={2}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField fullWidth label="Year" value={year} onChange={(e) => setYear(e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField select fullWidth label="Status" value={status} onChange={(e) => setStatus(e.target.value)}>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              <Grid align="left" mt={2}>
                <MDButton variant="contained" size="small" color="info" type="submit">
                  Update
                </MDButton>
              </Grid>
            </form>
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateYear;
